let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1RYWP")).then(() => parcelRequire('e9gZa'));